<script>
  export let expanded = false;
  export let icon = "";
  export let label = "Filter";

  let svgContent = "";

  $: if (icon && typeof icon === "string") {
    fetchSvg(icon);
  }

  import AccordionChevron from "../icons/AccordionChevron.svelte";

  function toggleExpanded() {
    expanded = !expanded;
  }

  function horizontalCollapse(node, { duration = 180 } = {}) {
    const width = parseFloat(getComputedStyle(node).width);
    const content = node.firstElementChild;
    const contentWidth = content && getComputedStyle(content).width;
    const originalContentWidth = content?.style.width;
    const originalContentWidthPriority =
      content?.style.getPropertyPriority("width");

    return {
      duration,
      css: (progress) => `width: ${width * progress}px; overflow: hidden;`,
      tick: (progress) => {
        if (!content) return;

        if (progress === 1) {
          if (originalContentWidth) {
            content.style.setProperty(
              "width",
              originalContentWidth,
              originalContentWidthPriority
            );
          } else {
            content.style.removeProperty("width");
          }
        } else {
          content.style.width = contentWidth;
        }
      },
    };
  }

  async function fetchSvg(url) {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      svgContent = await res.text();
      if (!svgContent.includes("width=") && !svgContent.includes("height=")) {
        svgContent = svgContent.replace(/<svg/g, '<svg width="16" height="16"');
      }
    } catch (error) {
      console.error(`Error fetching SVG: ${error}`);
      svgContent = `<svg width="16" height="16"><text x="0" y="15" font-size="15">?</text></svg>`;
    }
  }
</script>

<div class="bx-collapsible-menu_wrapper">
  {#if expanded}
    <div
      class="content_wrapper"
      transition:horizontalCollapse
      aria-hidden="{!expanded}"
    >
      <div class="content_inner">
        <slot />
      </div>
    </div>
  {/if}
  <button
    class="menu_border"
    class:border_left="{expanded}"
    type="button"
    aria-expanded="{expanded}"
    aria-label={'Toggle ' + label + ' panel'}
    on:click="{toggleExpanded}"
  >
    <span class="chevron" class:flip="{expanded}" aria-hidden="true">
      <AccordionChevron aria-label="expand/collapse" />
    </span>

    <span class="desc" aria-hidden="true">
      {#if $$slots.icon}
        <slot name="icon" />
      {:else if icon}
        {#if typeof icon === "function"}
          <svelte:component this="{icon}" />
        {:else}
          {@html svgContent}
        {/if}
      {/if}
      <span class="text">{label}</span>
    </span>

    <span class="chevron" class:flip="{expanded}" aria-hidden="true">
      <AccordionChevron aria-label="expand/collapse" />
    </span>
  </button>
</div>

<style>
  .bx-collapsible-menu_wrapper {
    display: flex;
    align-self: stretch;
    min-height: 0;
  }

  .bx-collapsible-menu_wrapper .chevron :global(svg) {
    width: 12px;
    height: 7px;
  }

  .menu_border {
    display: flex;
    flex: 0 0 3rem;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 3rem;
    align-self: stretch;
    height: auto;
    padding: 1rem;
    border: 0;
    border-left: 1px solid transparent;
    border-right: 1px solid #d9d9d9;
    background-color: white;
    color: #1c1c20;
    cursor: pointer;
    transition: border-left-color 180ms cubic-bezier(0.2, 0, 0.38, 0.9);
  }

  .menu_border:focus-visible {
    outline: 2px solid var(--cds-focus, #0f62fe);
    outline-offset: -2px;
  }

  .border_left {
    border-left-color: #d9d9d9;
  }

  .content_wrapper {
    box-sizing: border-box;
    height: 100%;
    flex: 0 0 auto;
    padding: 1rem;
    background-color: white;
  }

  .content_inner {
    height: 100%;
  }

  .chevron {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg) /*rtl:ignore*/;
    transform: rotate(90deg) /*rtl:ignore*/;
    transition: all 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  }

  .flip {
    transform: rotate(270deg);
    -webkit-transform: rotate(270deg) /*rtl:ignore*/;
    transform: rotate(270deg) /*rtl:ignore*/;
  }

  .desc {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    transform: rotate(270deg);
    font-size: 0.8rem;
  }
</style>
